import { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../../services/adminApi';
import AdminGrid from '../../components/admin/AdminGrid';
import FunnelChart from '../../components/admin/FunnelChart';

const fmtDate = (p) => p.value ? new Date(p.value).toLocaleDateString() : '-';

export default function CustomerJourney() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ signedUp: 0, connected: 0, active: 0, goodCustomer: 0, churned: 0 });
  const [selectedStage, setSelectedStage] = useState('GOOD_CUSTOMER');

  useEffect(() => { adminApi.getCustomerJourneyStats().then(setStats).catch(console.error); }, []);

  const columns = useMemo(() => [
    { field: 'orgName', headerName: 'Organization', minWidth: 180 },
    { field: 'superAdminName', headerName: 'Admin' },
    { field: 'superAdminEmail', headerName: 'Email', minWidth: 200 },
    { field: 'companiesCount', headerName: 'Companies', filter: 'agNumberColumnFilter' },
    { field: 'reportsCount', headerName: 'Reports', filter: 'agNumberColumnFilter' },
    { field: 'lastActivity', headerName: 'Last Activity', valueFormatter: fmtDate },
    { field: 'daysSinceSignup', headerName: 'Days', filter: 'agNumberColumnFilter' },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getCustomerJourneyOrgs(selectedStage, 0, 10000);
    return res.content || [];
  }, [selectedStage]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-100 mb-4">Customer Journey</h1>
      <FunnelChart stats={stats} selectedStage={selectedStage} onStageClick={setSelectedStage} />
      <AdminGrid
        columns={columns}
        fetchData={fetchData}
        onRowClick={(data) => navigate(`/admin/organizations/${data.orgId}`)}
      />
    </div>
  );
}
